import AuthView from "../views/auth/AuthView";
import Login from "../views/auth/Login";
import BoughtMomentos from "../views/FanScreens/BoughtMomentos";
import Gallery from "../views/FanScreens/Gallery";
import MakeRequests from "../views/FanScreens/MakeRequests";
import MyRequests from "../views/FanScreens/MyRequests";
import CreateMomentos from "../views/Mainview/CreateMomentos";
import Dashboard from "../views/Mainview/Dashboard";
import EditMomento from "../views/Mainview/EditMomento";
import FamilyQRcodes from "../views/Mainview/FamilyQRcodes";
import ManageMomentos from "../views/Mainview/ManageMomentos";
import MomentosDrafts from "../views/Mainview/MomentoDrafts";
import MomentoRequests from "../views/Mainview/MomentoRequests";
import RequestQRCode from "../views/Mainview/RequestQRCode";
import TermsAndConditions from "../views/Mainview/TermsAndConditions";
import UploadQRcode from "../views/Mainview/UploadQRcode";
import EditDraftMomento from "../views/Mainview/EditDraftMomento";
let routes = [
    {
        path: "/auth",
        component: AuthView,
        layout: "auth",
    },
    {
        path: "/index",
        component: Dashboard,
        layout: "main",
    },
    {
        path: "/mementos",
        component: ManageMomentos,
        layout: "main",
    },
    {
        path: "/gallery",
        component: Gallery,
        layout: "main",
    },
    {
        path: "/login",
        component: Login,
        layout: "auth",
    },
    {
        path: "/terms&conditions",
        component: TermsAndConditions,
        layout: "main",
    },
    {
        path: "/create-momentos/:id",
        component: CreateMomentos,
        layout: "main",
    },
    {
        path: "/edit-momento/:id",
        component: EditMomento,
        layout: "main",
    },
    {
        path: "/editDraft-momento/:id",
        component: EditDraftMomento,
        layout: "main",
    },
    {
        path: "/momentos-requests",
        component: MomentoRequests,
        layout: "main",
    },
    {
        path: "/my-requests",
        component: MyRequests,
        layout: "main",
    },
    {
        path: "/request",
        component: MakeRequests,
        layout: "main",
    },
    {
        path: "/bought-momentos",
        component: BoughtMomentos,
        layout: "main",
    },
    // {
    //     path: "/buy-momento/:id",
    //     component: BuyMomento,
    //     layout: "main",
    // },
    {
        path: "/qr-codes",
        component: FamilyQRcodes,
        layout: "main",
    },
    {
        path: "/qr-upload/:id",
        component: UploadQRcode,
        layout: "main",
    },
    {
        path: "/qr-request",
        component: RequestQRCode,
        layout: "main",
    },
    {
        path: "/momento_drafts",
        component: MomentosDrafts,
        layout: "main",
    },
];
export default routes;
